import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { DummyEntity } from '../dummy.js';

export const dummyQuery = registerQuery({
  operationName: 'dummyQuery',
  type: () => DummyEntity,
  resolve: () => () => {},
});
